import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  userForOrganizerData: any;
  userForOrganizerLoading: boolean;
  userForOrganizerError: SerializedError | null;
} = {
  userForOrganizerData: {},
  userForOrganizerLoading: false,
  userForOrganizerError: null,
};

export const userForOrganizerFunc = createAsyncThunk(
  'userForOrganizer/userForOrganizerFunc',
  async (values: { userId: string | null }) => {
    const accessTokenJSON = localStorage.getItem('auth');

    const data1 = JSON.stringify({
      query: `query User($userId: ID) {
        user(userId: $userId) {
            personalInformation {
            childAge
            name
            surname
            phoneNumber
            description
            profileImageUrl
            organization
            }
            role
            contact {
            email
            address {
                city
                district
            }
            phoneNumber
            }
            socialMedia {
              facebook
              instagram
              twitter
              website
              youtube
            }
            onboarded
            createdAt
            _id
        }
    }`,
      variables: {
        userId: values?.userId ?? null,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_USER || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const userForOrganizer = createSlice({
  name: 'userForOrganizer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userForOrganizerFunc.pending, (state) => {
      state.userForOrganizerLoading = true;
    });
    builder.addCase(userForOrganizerFunc.fulfilled, (state, action) => {
      state.userForOrganizerLoading = false;
      state.userForOrganizerData = action.payload?.data?.user;
      state.userForOrganizerError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(userForOrganizerFunc.rejected, (state, action) => {
      state.userForOrganizerLoading = false;
      state.userForOrganizerError = action.error;
    });
  },
});

export default userForOrganizer.reducer;
